import React from 'react';
import { motion } from 'framer-motion';

import UIConfig from '@/UIConfig.ts';

type CircularProgressBarProps = {
  progress: number;
  size?: number;
  strokeWidth?: number;
};

const CircularProgressBar: React.FC<CircularProgressBarProps> = ({
  progress,
  size = 100,
  strokeWidth = 4
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  const fullStroke = UIConfig.Colors.UploadProgress;
  const emptyStroke = '#818181';

  return (
    <>
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 2,
          borderRadius: '20px'
        }}
      />
      <div
        style={{
          position: 'absolute',
          width: size,
          height: size,
          zIndex: 3
        }}
      >
        <svg width={size} height={size}>
          <circle
            stroke={emptyStroke}
            fill="transparent"
            strokeWidth={strokeWidth}
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />

          <motion.circle
            stroke={fullStroke}
            fill="transparent"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            animate={{ strokeDashoffset: offset }}
            transition={{ duration: 0.3, ease: 'easeOut' }}
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />
        </svg>
      </div>
    </>
  );
};

export default CircularProgressBar;
